import { createSelector } from 'reselect'

const modalSelector = state => state.get('modal')

export const modalStatus = createSelector(
  modalSelector,
  modalImmutable => {
    const modal = modalImmutable.toJS()
    try {
      return modal.modal.modalStatus
    } catch (error) {
      return {}
    }
  }
)

export const modalType = createSelector(
  modalSelector,
  modalImmutable => {
    const modal = modalImmutable.toJS()
    try {
      return modal.modal.modalType
    } catch (error) {
      return {}
    }
  }
)

export const modalMessage = createSelector(
  modalSelector,
  modalImmutable => {
    const modal = modalImmutable.toJS()
    try {
      return modal.modal.modalMessage
    } catch (error) {
      return {}
    }
  }
)

export const confirmStatus = createSelector(
  modalSelector,
  modalImmutable => {
    const modal = modalImmutable.toJS()
    try {
      return modal.confirm.modalStatus
    } catch (error) {
      return {}
    }
  }
)

export const confirmType = createSelector(
  modalSelector,
  modalImmutable => {
    const modal = modalImmutable.toJS()
    try {
      return modal.confirm.modalType
    } catch (error) {
      return {}
    }
  }
)

export const confirmMessage = createSelector(
  modalSelector,
  modalImmutable => {
    const modal = modalImmutable.toJS()
    try {
      return modal.confirm.modalMessage
    } catch (error) {
      return {}
    }
  }
)



// WEBPACK FOOTER //
// ./src/selectors/modal/modal-selector.js